import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  style: {"height":"400px","width":"100%"},
  class: "position-relative"
}

import Api from "@/services/api"
    import { Ad, Area, Category } from "@/services/types"
    import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus"
    import { onBeforeMount, reactive, ref } from "vue"
    import { useRouter } from "vue-router"
    import { useStore } from "vuex"
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip, } from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePlace',
  setup(__props) {

    const store = useStore()
    const router = useRouter()
    const ad = reactive<Ad>({
        name: '',
        description: '',
        images: [],
        category_id: null,
        area: reactive<Area>({
            name: 'Bairo, rua, outras',
            lat: -19.84361, 
            long: 34.83889
        })
    })

    const rules = reactive<FormRules<Ad>>({
        name: [{required: true, message: 'Insira o nome do sitio', min: 1}],
        description: [{required: true, message: 'Informe a descricao'}],
        category_id: [{required: true, message: 'Precisa selecionar uma categoria'}],
        "area.name": [{required: true, message: 'Fornrça a localizacao'}],
        images: [{required: true, message: 'adicione pelo menos uma foto'}]
    })

    const images = ref()
    const uris = ref<string>()
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const loading = ref<boolean>(true)
    const map = ref()
    const zoom = ref<number>(15)
    const locating = ref<boolean>(false)

    const onMapClick = (event: LeafletMouseEvent) => {
        const { lat, lng } = event.latlng
        if (ad.area) {
            ad.area.lat = lat
            ad.area.long = lng
        } else {
            ad.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(ad.area);
    }
    
    const categories = reactive<Array<Category>>([])

    onBeforeMount(async () => {
        loading.value = true
        const res = await Api.get('admin/categories')
        if (res.status != 200) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message)
        } else {
            const data = res.data.categories
            categories.splice(0)
            data.forEach((element: Category) => {
                categories.push(element)
            });
        }
        loading.value = false
    })


    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (ad.area) {
                ad.area.lat = position.coords.latitude
                ad.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }

    const selectImages = () => {
        console.log(images.value?.input.files)
        ad.images?.splice(0)
        for (let i = 0; i < images.value?.input.files.length; i++) {
            ad.images?.push(images.value?.input.files[i])
        }

        console.log(ad.images)
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!ad.area?.lat || !ad.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const data = new FormData()
                data.append('name', ad.name)
                data.append('category_id', `${ad.category_id}`)
                data.append('description', ad.description)
                
                // Area
                if (ad.area) {
                    data.append('area[name]', ad.area.name)
                    data.append('area[lat]', ad.area.lat.toString())
                    data.append('area[long]', ad.area.long.toString())
                }
                

                // imagens
                ad.images?.forEach((img, i) => {
                    data.append(`images[${i}]`, img)
                })

                const res = await Api.post('admin/ads', ad, data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Local cadastrado com sucesso'})
                    store.commit('setOpenModal', -1)
                    
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createBlock(_component_el_skeleton, {
    rows: 12,
    loading: loading.value,
    animated: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        disabled: saving.value,
        rules: rules,
        model: ad,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            prop: "name",
            label: "Nome do local"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                name: "name",
                modelValue: ad.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ad.name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Selecionar categoria",
            prop: "category_id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: ad.category_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ad.category_id) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories, (c) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: c.name,
                      value: c.id,
                      key: c.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(c.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "images",
            label: "Adicione fotos do local"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                multiple: "",
                modelValue: uris.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((uris).value = $event)),
                type: "file",
                ref_key: "images",
                ref: images,
                name: "images",
                onChange: selectImages
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Descrição",
            prop: "description"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                name: "description",
                modelValue: ad.description,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ad.description) = $event)),
                minlength: "1"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (ad.area)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "Localização",
                prop: "area.name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    name: "loc",
                    modelValue: ad.area.name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ad.area.name) = $event)),
                    minlength: "1"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { label: "Selecione o local no mapa" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_button, {
                  plain: "",
                  class: "position-absolute end-0",
                  style: {"z-index":"1024"},
                  loading: locating.value || loading.value,
                  size: "large",
                  type: "success",
                  onClick: _withModifiers(locate, ["prevent"])
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" Localizar-me ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_unref(LMap), {
                  ref_key: "map",
                  ref: map,
                  zoom: zoom.value,
                  center: [ad.area?.lat ?? 0, ad.area?.long ?? 0],
                  onContextmenu: onMapClick
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(LTileLayer), {
                      url: "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga",
                      "layer-type": "base",
                      name: "Google"
                    }),
                    (ad.area)
                      ? (_openBlock(), _createBlock(_unref(LMarker), {
                          key: 0,
                          "lat-lng": [ad.area.lat, ad.area.long]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(LTooltip), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(ad.name), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["lat-lng"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["zoom", "center"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            plain: "",
            loading: saving.value,
            size: "large",
            type: "primary",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Cadastrar ", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["disabled", "rules", "model"])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})